import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../../../environments/environment";
import {DealerStatsDto} from "../../../../../auto-generated-server-dtos/adjuster/claim/dealer-stats/dealer-stats-dto";

@Injectable({
  providedIn: 'root'
})
export class GetDealerStatsService {

  constructor(private httpClient: HttpClient) { }

  public GetDealerStats(claimId: number): Observable<DealerStatsDto> {
    return this.httpClient.get<DealerStatsDto>(`${environment.apiServer}/Adjuster/GetDealerStats`, {params: {claimId: claimId}});
  }
}
